export class ShareOptions {
  id: string;
  name: string;
  email: string;
  rightToEdit: boolean;
  allowSharedFiles: boolean;
  comment: string;
  files: Array<string>;
}
